import type { FaireProductEntity } from "../../entity_types/product";

export const p_drd6s69d23: FaireProductEntity = {
  token: "p_drd6s69d23",
  type: "product",
  name: "18K Gold Plated Geometric Hoop Earrings",
  brandToken: "b_xju99kcstz",
  brandName: "paperln",
  imageUrl:
    "https://cdn.faire.com/fastly/272ac359ed7037a40b0e534a36bf61f73f61c10e13dfcf6c9f7221fcf07bc97a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc0d5286843a6c6c112b5864dc8f43a7f6246c63bbe5fd4a11c78d51cdea1dee.jpeg",
    "https://cdn.faire.com/fastly/ed664c6d3428a6ed401ef1c64968e579ad05795465fa637cabaaf7e956e23546.jpeg",
  ],
  priceDollars: 11.38,
  description:
    "Enhance your style with these elegant 18K gold plated geometric hoop earrings. Perfect for any occasion, these earrings offer a modern twist on a classic design. \n\n- Features:\n  - 18K gold plating for a luxurious finish\n  - Geometric design for a contemporary look\n  - Lightweight and comfortable for all-day wear\n\n- Styling Suggestions:\n  - Pair with a sleek updo to highlight the earrings\n  - Ideal for both casual and formal events\n\n- Care Instructions:\n  - Avoid contact with water and harsh chemicals\n  - Store in a cool, dry place\n  - Clean with a soft cloth to maintain shine",
  tags: [],
  msrpDollars: 22.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:20.209Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
